import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { class: "doc" }
const _hoisted_2 = ["innerHTML"]
const _hoisted_3 = {
  key: 1,
  class: "doc__empty"
}

import { computed } from 'vue'
import { useRoute } from 'vue-router'
import { findDoc } from '@/docs'
import { renderMarkdown } from '@/services/markdown'
import 'highlight.js/styles/github.css'


export default /*@__PURE__*/_defineComponent({
  __name: 'DocView',
  setup(__props) {

const route = useRoute()

const doc = computed(() => findDoc(decodeURIComponent(String(route.params.id))))
const html = computed(() => (doc.value ? renderMarkdown(doc.value.raw) : ''))

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (doc.value)
      ? (_openBlock(), _createElementBlock("article", {
          key: 0,
          class: "markdown-body",
          innerHTML: html.value
        }, null, 8, _hoisted_2))
      : (_openBlock(), _createElementBlock("div", _hoisted_3, [...(_cache[0] || (_cache[0] = [
          _createElementVNode("h2", null, "Документ не найден", -1),
          _createElementVNode("p", null, "Выберите документ в списке слева.", -1)
        ]))]))
  ]))
}
}

})